import Api from '@/api';

const checkout = (context, payload) => new Promise((resolve, reject) => {
  Api.subscriptionService.checkout(payload)
    .then(response => resolve(response.data))
    .catch(error => reject(error.data));
});

const acknowledge = (context, hostedPageId) => new Promise((resolve, reject) => {
  Api.subscriptionService.acknowledge(hostedPageId)
    .then(response => resolve(response.data))
    .catch(error => reject(error));
});

export default {
  checkout,
  acknowledge,
};
